<template>
  <div>
    <div
      class="btn-wrapper d-flex justify-content-md-end justify-content-center"
    >
      <button
        class="btn btn-outline-primary wizard-btn prev-btn"
        @click="previous"
      >
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        {{ $t("global.return") }}
      </button>
      <button class="btn btn-primary wizard-btn next-btn" @click="nextStep">
        {{ $t("global.save") }}
      </button>
    </div>
    <div class="card card-small mb-4 mt-3">
      <div class="card-body">
        <div class="py-2 px-3">
          <div class="row">
            <div class="col-lg-6">
              <recapitulatif-retour-regie-request
                :request="request"
                :show-last-two="false"
              />
            </div>
            <div class="col-lg-6">
              <h5 class="mt-3">Project / Actions :</h5>
              <span>{{ request.description }}</span>
            </div>
            <div class="col-12 ml-5">
              <div class="row">
                <a class="download-document-button" :href="request.excelDoc" rel="external" target="_blank"><i class="fa fa-paperclip fa-lg mr-2" aria-hidden="true"></i>Document Excel</a>
                <button v-for="doc in request.documentsPaths" class="download-document-button" @click="downloafUpload(doc.path)"><i class="fa fa-paperclip fa-lg mr-2" aria-hidden="true"></i>{{doc.name}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RecapitulatifRetourRegieRequest from '../RecapitulatifRetourRegieRequest.vue';
import { ref, uploadBytes, uploadBytesResumable, getDownloadURL, getBlob } from "firebase/storage";
import {storage} from '../../../firebase/app';

export default {
  name: 'StepThree',
  components: { RecapitulatifRetourRegieRequest },
  props: ['user', 'request'],

  methods: {
    previous() {
      this.$emit('input', null);
    },
    nextStep() {
      this.$emit('input', true);
    },
    downloafUpload(filePath) {
      getDownloadURL(ref(storage, filePath))
        .then((url) => {
          let path = filePath;
          const xhr = new XMLHttpRequest()
          xhr.responseType = 'blob';
          xhr.open('GET', url)
          xhr.send()
          xhr.onload = function () {
            const blob = new Blob([xhr.response])
            const a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = path
            a.click()
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style lang="scss">
.underline {
  text-decoration: underline;
}
.five {
  p {
    margin: 0;
  }
  .d-flex {
    padding: 1rem;
    align-content: center;
    align-items: center;
  }
}
.card {
  position: relative;
  background-color: transparent;
}
.wizard-btn-wrapper {
  position: absolute;
  top: -120px;
  right: 0;
}

.download-document-button {
  border: 1px #BECAD6 solid;
  border-radius: 5px;
  padding: 5px 30px 5px 10px;
  // width: 150px;
  display: flex;
  justify-content: space-around;
  margin-right: 10px;
  margin-bottom: 50px;
  margin-top: 20px;
  color: #212121 !important;
}

.download-document-button i {
  margin-top: 2px;
}

.download-document-button:last-of-type {
  padding: 5px 10px 5px 10px;
}
</style>
